import React from "react";
import UserLayout from "../../components/user/UserLayout";
import { Card, Row, Col } from "react-bootstrap";
import { FaFilePdf, FaExternalLinkAlt, FaFolderOpen } from "react-icons/fa";

const documents = [
  {
    category: "Majistral Rehberler",
    items: [
      {
        title: "Majistral Reçete Hazırlama Kılavuzu",
        url: "https://example.com/majistral-kilavuz.pdf",
      },
      {
        title: "Majistral Stabilite Rehberi",
        url: "https://example.com/stabilite-rehberi.pdf",
      },
    ],
  },
  {
    category: "TEB Belgeleri",
    items: [
      {
        title: "TEB Majistral Rehberi",
        url: "https://www.teb.org.tr/",
      },
      {
        title: "TEB Standartlar Dokümanı",
        url: "https://www.teb.org.tr/",
      },
    ],
  },
  {
    category: "SGK ve SUT Belgeleri",
    items: [
      {
        title: "Güncel SUT Dokümanı",
        url: "https://example.com/sut.pdf",
      },
      {
        title: "SGK Majistral Ödeme Kılavuzu",
        url: "https://example.com/sgk-majistral.pdf",
      },
    ],
  },
];

const DocumentsPage = () => {
  return (
    <UserLayout>
      <h2 className="fw-bold mb-3" style={{ color: "#2D8A7A" }}>
        Dokümanlar
      </h2>

      <p className="text-muted mb-4">
        Majistral formülasyonlar, SGK – SUT dosyaları, mesleki rehberler ve
        önemli dokümanlara buradan ulaşabilirsiniz.
      </p>

      {documents.map((section, index) => (
        <div key={index} className="mb-5">
          {/* 📁 Kategori Başlığı */}
          <h5
            className="fw-bold mb-3 d-flex align-items-center"
            style={{ color: "#2D8A7A" }}
          >
            <FaFolderOpen className="me-2" />
            {section.category}
          </h5>

          {/* 🧾 Doküman Kartları */}
          <Row className="g-3">
            {section.items.map((doc, i) => (
              <Col md={4} key={i}>
                <Card className="p-3 shadow-sm rounded-4 h-100">
                  <h6 className="fw-bold d-flex align-items-center mb-2">
                    <FaFilePdf className="me-2 text-danger" />
                    {doc.title}
                  </h6>

                  <a
                    href={doc.url}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-outline-primary w-100 mt-auto"
                  >
                    Aç <FaExternalLinkAlt className="ms-2" />
                  </a>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      ))}

      {/* 📢 Reklam Alanı */}
      <Card
        className="p-4 shadow-sm rounded-4 text-center mt-5"
        style={{
          background: "#f8fafc",
          border: "2px dashed #cdd6dd",
        }}
      >
        <h6 className="fw-bold mb-2">Reklam Alanı</h6>
        <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
          Bu alana reklam verebilirsiniz, bizimle iletişime geçin.
        </p>
      </Card>
    </UserLayout>
  );
};

export default DocumentsPage;
